import type { ResultsModalTasks } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/task.tsx';

export const getCmdbAsyncActionsResultsModalEntrypointProps = ({
	taskId,
	operationType,
	resultPayload,
}: ResultsModalTasks) => ({
	taskId,
	operationType,
	resultPayload,
});
